import { createSelector } from 'reselect';

const postbacks = (state) => state.postbacks.list.data;
const getIdFromProps = (_, props = {}) => props?.params?.id;

export const makeGetPostback = () => createSelector(
    postbacks,
    getIdFromProps,
    (postbacks = [], id) => {
        if (!id) {
            return postbacks[0] && postbacks[0].config ? postbacks[0].config : {};
        }

        const matched = postbacks.find((item) => String(item.id) === String(id));
        return (matched && matched.config) || {};
    }
);
